var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-card"},[_c('el-image',{attrs:{"src":_vm.file.url,"preview-src-list":_vm.images.map(im => im.url)}}),_c('div',{staticClass:"image-card__name"},[_vm._v(_vm._s(_vm.file.fileName))]),(_vm.isEdited)?_c('span',{staticClass:"image-card__close",on:{"click":_vm.onRemove}},[_c('i',{staticClass:"el-icon-close"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }